import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getLastVehiclesRequest } from 'store/modules/comuns/lastVehicles/reducer'
import { FormCombobox } from 'components/CoForm/components'

export function ComboboxLastVehicles(props) {
  const dispatch = useDispatch()
  const vehicles = useSelector((state) => state.comuns.lastVehicles.vehicles)

  const options = useMemo(() => {
    return vehicles.map((vehicle) => ({
      value: vehicle.wev_placa,
      label: vehicle.wev_placa,
      truckTypeId: vehicle.id_tipo_caminhao,
    }))
  }, [vehicles])

  useEffect(() => {
    dispatch(getLastVehiclesRequest())
  }, [dispatch])

  return (
    <FormCombobox
      className="FormRow-plate"
      id="combo-last-vehicles"
      options={options}
      {...props}
    />
  )
}

export default ComboboxLastVehicles
